import logoLarge from "../images/Logo large.png";
import phone from "../images/iconmonstr-smartphone-7 1.svg";
import time from "../images/iconmonstr-time-3 1.svg";
import facebook from "../images/iconmonstr-facebook-6.svg";
import logo from "../images/logo.png";
//router
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import styled from "styled-components";

const Header = () => {
  const { pathname } = useLocation();
  return (
    <header className="header" id="header">
      <div className="header__logo-large">
        <Link to="/">
          <img
            className="header__logo-large--img"
            src={logoLarge}
            alt="Murphy Gardens Logo"
          />
        </Link>
      </div>
      <div className="header__info">
        <div className="header__hours">
          <img className="header__icon" src={time} alt="hours" />
          <p className="header__hours-text">Mon - Sat 9.00 - 18.00</p>
        </div>
        <div className="header__contact">
          <a className="contact-anchor" href="tel:07470359110">
            <img
              className="header__icon header__icon-phone"
              src={phone}
              alt="contact details"
            />
            <p className="header__contact-text-phone">(+44) 07470 359110</p>
          </a>
          <a className="contact-anchor" href="mailto:murphygardens1@gmail.com">
            <p className="header__contact-text-email">
              murphygardens1@gmail.com
            </p>
          </a>
        </div>
        <div>
          <Link to="/contact" className="btn">
            GET A QUOTE
          </Link>
        </div>
      </div>
      <div className="mobile__nav">
        <div className="navigation">
          <input
            type="checkbox"
            className="navigation__checkbox"
            id="navi-toggle"
          />
          <label htmlFor="navi-toggle" className="navigation__button">
            <span className="navigation__icon">&nbsp;</span>
          </label>
          <div className="navigation__background">&nbsp;</div>

          <nav className="navigation__nav">
            <ul className="navigation__list">
              <li className="navigation__item">
                <Link
                  to="/"
                  className="navigation__link"
                  onClick={() => {
                    document.getElementById("navi-toggle").checked = false;
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="navigation__item">
                <Link
                  to="/about"
                  className="navigation__link"
                  onClick={() => {
                    document.getElementById("navi-toggle").checked = false;
                  }}
                >
                  About
                </Link>
              </li>
              <li className="navigation__item">
                <Link
                  to="/pricing"
                  className="navigation__link"
                  onClick={() => {
                    document.getElementById("navi-toggle").checked = false;
                  }}
                >
                  Pricing
                </Link>
              </li>
              <li className="navigation__item">
                <Link
                  to="/gallery"
                  className="navigation__link"
                  onClick={() => {
                    document.getElementById("navi-toggle").checked = false;
                  }}
                >
                  Gallery
                </Link>
              </li>
              <li className="navigation__item">
                <Link
                  to="/contact"
                  className="navigation__link"
                  onClick={() => {
                    document.getElementById("navi-toggle").checked = false;
                  }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="header__nav">
        <div className="header__nav-inside">
          <ul className="header__nav-items">
            <li className="header__li-nav">
              <Link to="/" className={`header__nav-link ${pathname === "/" ? "header__nav-link--active" : ""}`}>
                Home
              </Link>
              <Line
                transition={{ duration: 0.75 }}
                initial={{ width: "0" }}
                animate={{ width: pathname === "/" ? "60%" : "0" }}
              />
            </li>
            <li className="header__li-nav">
              <Link to="/about" className={`header__nav-link ${pathname === "/about" ? "header__nav-link--active" : ""}`}>
                About
              </Link>
              <Line
                transition={{ duration: 0.75 }}
                initial={{ width: "0" }}
                animate={{ width: pathname === "/about" ? "60%" : "0" }}
              />
            </li>
            <li className="header__li-nav">
              <Link to="/gallery" className={`header__nav-link ${pathname === "/gallery" ? "header__nav-link--active" : ""}`}>
                Gallery
              </Link>
              <Line
                transition={{ duration: 0.75 }}
                initial={{ width: "0" }}
                animate={{ width: pathname === "/gallery" ? "60%" : "0" }}
              />
            </li>
            <li className="header__li-nav">
              <Link to="/pricing" className={`header__nav-link ${pathname === "/pricing" ? "header__nav-link--active" : ""}`}>
                Pricing
              </Link>
              <Line
                transition={{ duration: 0.75 }}
                initial={{ width: "0" }}
                animate={{ width: pathname === "/pricing" ? "60%" : "0" }}
              />
            </li>
            <li className="header__li-nav">
              <Link to="/contact" className={`header__nav-link ${pathname === "/contact" ? "header__nav-link--active" : ""}`}>
                Contact
              </Link>
              <Line
                transition={{ duration: 0.75 }}
                initial={{ width: "0" }}
                animate={{ width: pathname === "/contact" ? "60%" : "0" }}
              />
            </li>
          </ul>
          <div className="header__nav-networks">
            <a
              className="header__nav-networks-link"
              href="https://www.facebook.com/murphygardens1/"
            >
              <img src={facebook} alt="facebook" />
            </a>
          </div>
          <img className="header__nav-logo" src={logo} alt="logo" />
        </div>
      </div>
    </header>
  );
};

const Line = styled(motion.div)`
  height: 0.4rem;
  background: #2d652c;
  width: 0%;
  position: absolute;
  bottom: -80%;
  left: 20%;
  z-index: 2000;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(45, 101, 44, 0.3);
`;

export default Header;
